var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKcal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "#4D9F6F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7072 6.00517L10.7083 6.00616C11.1729 6.44969 11.5233 6.93863 11.7644 7.47305C12.0036 8.00299 12.1248 8.57819 12.125 9.20323C12.1205 9.75388 12.0131 10.2617 11.8055 10.7308C11.596 11.2042 11.304 11.6172 10.9278 11.9722C10.5499 12.3288 10.111 12.6107 9.6081 12.8176C9.11268 13.0215 8.57831 13.1248 8.00133 13.125C7.41748 13.1207 6.87901 13.0169 6.38242 12.8166C5.88183 12.6148 5.44724 12.3343 5.07531 11.9752C4.70183 11.6146 4.40825 11.1974 4.19333 10.7215C3.98214 10.2538 3.8753 9.7504 3.875 9.20696C3.87948 8.85052 3.92889 8.50055 4.02335 8.15627C4.05981 8.0234 4.10402 7.89418 4.15596 7.76851C4.25516 7.919 4.36651 8.0579 4.49015 8.18466C4.64847 8.34698 4.83128 8.47647 5.0368 8.57176C5.25765 8.67415 5.50158 8.72013 5.75974 8.72063C6.00056 8.72566 6.23105 8.68317 6.44506 8.58704C6.64052 8.49924 6.81742 8.38318 6.97408 8.23918C7.13803 8.08848 7.26655 7.91036 7.35772 7.70729C7.45065 7.50033 7.49609 7.27995 7.49609 7.05034H7.49627L7.49592 7.03879C7.49014 6.85125 7.45804 6.67138 7.39497 6.50281C7.33421 6.34044 7.24774 6.18804 7.13895 6.04562C6.94602 5.78755 6.80535 5.53635 6.71197 5.29221C6.62309 5.05981 6.57524 4.79147 6.575 4.48218C6.57941 4.1454 6.63951 3.83316 6.75314 3.54264C6.86706 3.25138 7.03157 2.98929 7.24867 2.7547C7.4681 2.51759 7.72272 2.32175 8.01436 2.16666L7.84042 1.8396L8.01436 2.16666C8.03643 2.15492 8.05866 2.14351 8.08105 2.13242C8.19459 2.07618 8.3062 2.08814 8.4229 2.16958C8.54995 2.25824 8.66518 2.42342 8.71313 2.62163C8.8258 3.08738 8.98681 3.53384 9.19616 3.96049C9.56365 4.70946 10.0687 5.39099 10.7072 6.00517Z",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKcal);
export default __webpack_public_path__ + "static/media/kcal.3b5e88d164f0891b898f0747594d18a3.svg";
export { ForwardRef as ReactComponent };